export default function Outlet() {
  return (
    <div
      className="ion-icon-outlet"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
<g>
	<path d="M369.541,32H142.359C81.521,32,32,82.574,32,144.604v222.79C32,429.426,81.521,480,142.359,480h227.182
		C430.479,480,480,429.426,480,367.395v-222.79C480,82.574,430.479,32,369.541,32z M175,250.954v0.67
		c0,10.882-9.09,20.376-19.875,20.376h-23.27C121.073,272,112,262.506,112,251.624v-0.67V149.512v-1.351
		c1-10.768,9.193-20.161,19.855-20.161h23.27c10.886,0,19.875,9.847,19.875,20.831V250.954z M297,395.74v2.68
		c0,11.439-8.872,17.58-20.1,17.58H256h-20.898C223.872,416,215,407.859,215,396.42v-0.68v-28.637
		c0-23.33,18.118-42.287,40.999-42.287c22.883,0,41.001,18.957,41.001,42.287V395.74z M400,250.954v0.67
		c0,10.882-9.071,20.376-19.855,20.376h-24.27C345.093,272,336,262.506,336,251.624v-0.67V149.512v-1.351
		c1-10.768,9.215-20.161,19.875-20.161h24.27c10.784,0,19.855,9.847,19.855,20.831V250.954z"/>
</g>
</svg>
`,
      }}
    />
  )
}
